module.exports = __webpack_public_path__ + "media/images/front/pc/treatment-introduction-article/kv-e7945d95ab978631d6e5967d9300aa01.png";